import React, { useId } from 'react';
import classNames from 'classnames';
import {useTranslations} from '../../context/TranslationContext';
import './CheckboxField.less';

const CheckboxField = ({
    label,
    checked,
    isChecked,
    onChange,
    id,
    checkboxId,
    name,
    value,
    disabled = false,
    className,
    inputProps = {},
    inputClassName,
    ref,
    helperText,
    isIndeterminate = false,
    card = false,
    vertical = false,
}) => {
    const { t } = useTranslations();
    const autoId = useId();
    const inputId = id || checkboxId || autoId;
    const checkedState = checked !== undefined ? checked : isChecked;
    const helperId = helperText ? `${inputId}-helper` : undefined;

    // `indeterminate` is a DOM property only — there is no attribute for it.
    // Inline callback ref: runs on every render AND on remounts (e.g. when the
    // `card` prop toggles), so the property never silently resets.
    const setControlRef = (node) => {
        if (node) {
            node.indeterminate = isIndeterminate;
        }
        if (typeof ref === 'function') {
            ref(node);
        } else if (ref) {
            ref.current = node;
        }
    };

    const row = (
        <div className={classNames('checkbox-row', className, { disabled, 'has-helper-text': helperText, vertical })}>
            <label htmlFor={inputId}>
                <input
                    {...inputProps}
                    className={classNames(inputProps.className, inputClassName) || undefined}
                    ref={setControlRef}
                    type="checkbox"
                    id={inputId}
                    name={name}
                    value={value}
                    checked={checkedState}
                    onChange={onChange}
                    disabled={disabled}
                    aria-describedby={helperId}
                />
                {t(label)}
            </label>
            {helperText && <div className="helper-text" id={helperId}>{t(helperText)}</div>}
        </div>
    );

    if (!card) {
        return row;
    }
    return (
        <div className={classNames('checkbox-card', { checked: checkedState, disabled })}>
            {row}
        </div>
    );
};


export default CheckboxField;
